module.exports = __webpack_public_path__ + "img/cleanRag.21987c40.webp";